<template>
  <div
    class="complex-text-widget"
    :style="style"
  >
    <span
      v-for="(part, index) in widget.parts"
      :key="index"
      :style="partStyle(part)"
      @click="click($event, part)"
    >{{ part.text }}</span>
  </div>
</template>

<script>
export default {
  name: 'ComplexTextWidgetView',
  props: {
    widget: {
      type: Object,
      required: true,
    },
  },
  computed: {
    style() {
      return {
        left: this.widget.left === 'unset' ? this.widget.left : `${this.widget.left}px`,
        right: this.widget.right === 'unset' ? this.widget.right : `${this.widget.right}px`,
        top: `${this.widget.top}px`,
        height: `${this.widget.height}px`,
        width: `${this.widget.width}px`,
        zIndex: this.widget.zIndex,
        transform: `rotate(${this.widget.rotate}deg)`,
        justifyContent: this.widget.textAlign,
        textAlign: this.widget.textAlign,
        direction: this.widget.direction,
        alignItems: this.widget.verticalAlign,
        borderRadius: this.widget.borderRadius,
        padding: this.widget.padding,
      };
    },
  },
  methods: {
    click(e, part) {
      if (part.url) {
        this.$emit('userInteraction', {
          eventName: 'StoryExternalLinkClicked',
          url: part.url,
        });
        window.open(part.url, '_blank');
        e.stopPropagation();
      }
    },
    partStyle(part) {
      return {
        background: part.background,
        color: part.color,
        fontSize: `${part.fontSize}px`,
        fontFamily: part.fontFamily,
        lineHeight: `${part.lineHeight}px`,
        ...(part.url ? { cursor: 'pointer' } : {}),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.complex-text-widget {
  position: absolute;
  display: block;
  white-space: pre-wrap;
}
</style>
